/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react/macro"
import React from "react"
import LocationsBindingQuestionTable from "./LocationsBindingQuestionTable"

const componentStyle = css`
    margin-top: 15px;
`
class LocationBindingQuestions extends React.Component{

    render(){
        const { applicationsContainer } = this.props
        const questionSets = applicationsContainer.state.locationsBindingQuestions
        
        return(
            <div css={componentStyle}>
                <div className="row">
                    <div className="col">
                        <h3>Locations</h3>
                        <p className="directions">Please enter the requested information as it should appear on the financial assurance certificate.</p>
                        {questionSets.map((questionSet, index)=>(
                            ((questionSet.locations.length > 0) &&
                                <LocationsBindingQuestionTable key={index}
                                                               questionSet={questionSet}
                                                               applicationsContainer = {applicationsContainer} />
                            )
                        ))}                        
                    </div>
                </div>
            </div>
        )
    }   
}

export default LocationBindingQuestions